export enum DepreciationMethodType
{
    None = 'None',
    Immediate = 'Immediate',   
    StraightLine = 'StraightLine',
}